import { ApplicantStatusesEnum } from '@thinknet-gmbh/platform-common';

import { DEFAULT_STATUSES, FIRST_VIEW_STATUSES } from './applicant-details-form.constants';

export const checkIfFirstView = ({ interviews, feedbacks, status }: any) =>
  !FIRST_VIEW_STATUSES.includes(status) && !interviews.length && !feedbacks.length;

export const getCurrentApplicantStatus = (initialValues: any, formValues: any) => {
  const { feedbacks, status } = initialValues;
  const { interviews, feedbacks: formFeedbacks, additionalInterviews } = formValues;

  if (
    (interviews?.length > 0 || additionalInterviews?.length > 0) &&
    DEFAULT_STATUSES.includes(status)
  ) {
    return ApplicantStatusesEnum.INTERVIEW_PHASE;
  }

  if (!feedbacks.length && formFeedbacks?.length > 0 && status === ApplicantStatusesEnum.NEW) {
    return ApplicantStatusesEnum.CANDIDATE_REVIEW;
  }
};
